const hi = {
    "1 day": "1 दिन",
    "1 month": "1 महीना",
    "6 weeks": "6 सप्ताह",
    "7 day": "7 दिन",
    "9w-deposit": "अदला-बदली जमा",
    "9w-withdraw": "अदला-बदली निकालना",
    added: "जोड़ा",
    about: "के बारे में",
    "about-us": "कंपनी के बारे में",
    aboutus_page: "कंपनी के बारे में",
    account: "खाता",
    account_number1: "खाता संख्या",
    accountname: "खाता नाम",
    active_bonus_tab: "सक्रिय",
    add_another_address: "दूसरा पता जोड़ें",
    add_bank: "बैंक जोड़ें",
    add_bank_account: "बैंक खाता जोड़ें",
    add_wallet_aadress: "कृपया बटुए का पता दर्ज करें",
    add_wallet_address: "वॉलेट पता जोड़ें",
    address: "पता",
    "adhaar card": "आधार कार्ड",
    "adjustment by admin": "व्यवस्थापक द्वारा समायोजन",
    affiliates: "सहबद्ध",
    affiliates_page: "सहबद्धों",
    age_validation: "आयु 18+ वर्ष होनी चाहिए",
    all: "सभी",
    all_provider_games_excluded: "सभी प्रदाता गेम्स बहिष्कृत हैं",
    all_provider_games_included: "सभी प्रदाता गेम्स शामिल हैं",
    already_have_an_account: "पहले से ही खाता है?",
    amount: "रकम",
    amount_after_fee: "शुल्क के बाद राशि",
    amount_between: "राशि के बीच होनी चाहिए|",
    amount_less_than_balance: "निकासी अनुरोध राशि उपलब्ध शेष राशि से अधिक है।",
    amount_less_than_fee_amount: "राशि शुल्क राशि से अधिक होनी चाहिए",
    amount_won: "जीती गई राशि",
    and: "और",
    App: "ऐप",
    app_description:
        "तेज़ प्रदर्शन, स्वचालित नेविगेशन, रियल टाइम अपडेट्स, और आपके पसंदीदा गेम्स और स्पोर्ट्स तक पहुंच।",
    app_exchange_description: "ट्रेड, बेट और संभावनाएं तुरंत देखें।",
    app_exclusive_bonuses: "विशेष बोनस",
    app_exclusive_bonuses_description:
        "विशेष एंड्रॉइड-केवल ऑफर और प्रोमोशन को अनलॉक करें।",
    app_faster_experience: "तेज़ अनुभव",
    app_faster_experience_description:
        "एंड्रॉइड डिवाइसों के लिए ऑप्टिमाइज़ेड प्रदर्शन।",
    app_install_step1: "APK फ़ाइल डाउनलोड करें",
    app_install_step2: "अज्ञात स्रोतों से स्थापित करने की अनुमति दें",
    app_install_step3: "फ़ाइल खोलें और स्थापना पूरी करें",
    app_install_steps: "3 आसान चरणों में स्थापित करें",
    app_instant_notifications: "तत्काल सूचनाएं",
    app_instant_notifications_description:
        "बेट्स, स्पोर्ट्स, और प्रोमोशन पर लाइव अपडेट्स प्राप्त करें।",
    app_pagetitle: "एंड्रॉइड ऐप",
    app_scan_to_download:
        "अपने एंड्रॉइड डिवाइस पर सीधे डाउनलोड करने के लिए स्कैन करें",
    app_secure_private: "सुरक्षित और खास",
    app_secure_private_description: "आपका खाता और लेनदेन सुरक्षित रहते हैं।",
    app_sports_description:
        "जीवनयापन स्पोर्ट्स बेटिंग के साथ खोजें तत्काल अपडेट्स।",
    app_title: "नवीन Sky365 एंड्रॉइड ऐप डाउनलोड करें",
    app_why_use_new_android_app: "नवीन Sky365 एंड्रॉइड ऐप का उपयोग क्यों करें?",
    app_why_use_new_android_app_description:
        "तेज़ प्रदर्शन, विश्वसनीयता, और एक बेहतर मोबाइल अनुभव के लिए निर्मित।",
    applied: "लागू",
    apply: "अप्लाइ",
    apply_bonus: "बोनस लागू करें",
    approved: "स्वीकृत",
    awaited: "बहुप्रतीक्षित",
    back: "वापस",
    bad_response_9W_insufficient_withdraw_balance:
        "इस निकासी का अनुरोध करने के लिए मुख्य वॉलेट में पर्याप्त धनराशि नहीं है। कृपया बाद में पुन: प्रयास करें",
    bad_response_amount: "कृपया राशि दर्ज करें",
    bad_response_bank_required: "कृपया बैंक चुनें",
    bad_response_current_password: "कृपया वर्तमान पासवर्ड दर्ज करें",
    bad_response_document_type: "कृपया दस्तावेज़ प्रकार चुनें",
    bad_response_expire_date: "कृपया एक समाप्ति तिथि दर्ज करें",
    bad_response_invalid_email: "कृपया एक वैध ईमेल पता दर्ज करें",
    bad_response_new_password: "कृपया नया पासवर्ड दर्ज करें",
    bad_response_select_attachment: "कृपया एक दस्तावेज़ चुनें.",
    bad_response_select_back_document: "कृपया दस्तावेज़ का पिछला भाग चुनें.",
    bad_response_select_front_document:
        "कृपया दस्तावेज़ के सामने वाले भाग चुनें|",
    bad_response_valid_age: "आयु 18 वर्ष होनी चाहिए",
    bad_response_validation_amount: "राशि एक संख्या होनी चाहिए",
    "balance added": "शेष जोड़ा गया",
    "balance adjustment": "संतुलन समायोजन",
    "balance subtracted": "शेष घटाया गया",
    balance_type: "बैलेंस प्रकार",
    balanceAdjustment: "समायोजन",
    bank_account_created: "बैंक खाता सफलतापूर्वक जोड़ा गया",
    bank_account_detail: "खाता विवरण",
    bank_account_id: "बैंक खाता आईडी",
    bank_account_length:
        "खाता संख्या अमान्य है, यह 9 से 18 अंकों के बीच होनी चाहिए।",
    bank_account_updated: "बैंक खाता सफलतापूर्वक अद्यतन किया गया",
    bank_approved_messsage: "आपका बैंक दस्तावेज़ स्वीकृत हो गया है.",
    bank_deletion_success: "आपका बैंक सफलतापूर्वक हटा दिया गया है",
    bank_doc_approval: "02  बैंक दस्तावेज़ सत्यापन",
    bank_name: "बैंक का नाम",
    bank_name_label: "बैंक का नाम",
    bank_name1: "बैंक का नाम",
    bank_rejected_message: "आपका बैंक दस्तावेज़ अस्वीकार कर दिया गया है.",
    banking: "बैंकिंग",
    beneficiary_name1: "लाभार्थी का नाम",
    bet: "बेट",
    "bet settled": "बेट सेटल्ड",
    bet_amount: "बेट राशि",
    betdiscard: "बेट त्यागना",
    betid: "बेट आईडी",
    betid_success_copied: "बेट आईडी सफलतापूर्वक कॉपी की गई",
    betslipid_success_copied: "बेटस्लिप आईडी सफलतापूर्वक कॉपी की गई",
    biometrics_updated_successfully: "बायोमेट्रिक्स सफलतापूर्वक अद्यतन किया गया",
    BlankNotificationDataError_message:
        "विवरण प्राप्त करने के लिए कृपया अपना ईमेल या फ़ोन नंबर दर्ज करें।",
    blog: "ब्लॉग",
    blog_page: "ब्लॉग",
    bonus: "बोनस",
    "bonus credited": "बोनस जमा किया गया",
    "bonus reverted": "बोनस वापस कर दिया गया",
    bonus_activated: "सक्रिय",
    bonus_amount: "बोनस राशि",
    bonus_claiming_date: "दावा तिथि",
    bonus_crediting_time: "जमा करने का समय",
    bonus_cycle_cap: "साइकिल कैप",
    bonus_end_date: "समाप्ति तिथि",
    bonus_name: "बोनस का नाम",
    bonus_promo_cap: "प्रोमो कैप",
    bonuscanceldate: "रद्द की गई तारीख",
    bonusconsumeddate: "खपत तिथि",
    bonusdescription: "विवरण",
    bonusexpireddate: "अवधि समाप्त तारीख",
    bonusexpiringdate: "समाप्ति तिथि",
    both: "दोनों",
    branch_name1: "शाखा का नाम",
    Call: "कॉल",
    cancel: "रद्द",
    cancel_btn: "रद्द करें",
    cancel_deposit_bonus_message:
        "क्या आप वाकई इस जमा बोनस को रद्द करना चाहते हैं?",
    cancel_deposit_bonus_success: "जमा बोनस सफलतापूर्वक रद्द किया गया।",
    cancel_ladder_bonus:
        "यह बोनस {0} चरणों वाली बोनस सीढ़ी का हिस्सा है। वर्तमान चरण के रद्द होने की पुष्टि करने पर अन्य {1} चरण भी स्वतः रद्द हो जायेंगे",
    cancelbonus: "बोनस रद्द करें",
    cancelled_bonus_tab: "रद्द हो चुका",
    cashback: "नकदी वापस",
    cashback_days: "कैशबैक दिन",
    cashback_dates: "कैशबैक तिथियाँ",
    cashback_play_time: "कैशबैक खेलने का समय",
    cashdrop_bonus: "कैशड्रॉप",
    cashout: "नकदीकरण",
    casino: "कैसीनो",
    "casino bet placed": "कैसीनो बेट लगाई गई",
    "casino bet resettled": "कैसीनो शर्त पुनर्स्थापित हो गई",
    "casino bet settled": "कैसीनो शर्त तय हो गई",
    casino_bet: "कैसीनो दांव",
    change: "बदलें",
    change_btn: "बदलना",
    change_language: "भाषा बदलें",
    change_method: "विधि बदलें",
    change_password: "पासवर्ड बदलें",
    change_password_validation_required: "दर्ज करना आवश्यक है",
    change_password_validation_length:
        "पासवर्ड 6 से 20 वर्णों के बीच होना चाहिए",
    change_password_validation_charset:
        "पासवर्ड में संख्याएँ (0-9), अक्षर (a-z, A-Z) और विशेष वर्ण (!@#$%^&*) हो सकते हैं, रिक्त स्थान नहीं",
    change_password_validation_not_same_as_current:
        "नया पासवर्ड वर्तमान पासवर्ड के समान नहीं होना चाहिए",
    change_password_validation_not_same_as_username:
        "नया पासवर्ड उपयोगकर्ता नाम के समान नहीं होना चाहिए",
    check_deposit_status: "अपनी जमा स्थिति की जांच करें",
    choose_document_type: "दस्तावेज़ का प्रकार",
    choose_avatar: "अवतार चुनें",
    choose_your_deposit_method: "जमा विधि चुनें",
    claim: "दावा",
    claim_until: "दावा करें तक",
    clear: "क्लीयर",
    commission: "दलाली",
    confirm_btn: "पुष्टीकरण",
    confirm_delete: "पुष्टीकरण",
    confirm_new_password: "नया पासवर्ड कन्फर्म करें",
    confirm_password: "कृपया नये पासवर्ड की पुष्टि करें",
    confirm_revert_deposit: "क्या आप वाकई इस जमा को रद्द करना चाहते हैं?",
    confirm_withdraw:
        "क्या आप वाकई इस निकासी के साथ आगे बढ़ना चाहते हैं? ऐसा करने से आपका सक्रिय बोनस स्वतः ही अपरिवर्तनीय रूप से समाप्त हो जाएगा।",
    confirmation_Message_For_Skip_Verification:
        "कृपया अपने प्रोफ़ाइल अनुभाग से बाद में रद्द करने या कार्रवाई करने के अपने निर्णय की पुष्टि करें। यह संदेश दोबारा नहीं दिखाया जाएगा। क्या आप सुनिश्चित हैं कि आप सत्यापन प्रक्रिया छोड़ना चाहते हैं?",
    consumed_bonus_tab: "ग्रहण",
    Contact_Preferences: "संपर्क प्राथमिकताएँ",
    continue: "जारी रखें",
    create_an_account: "खाता बनाएं",
    crypto_deposit_mobile_verify:
        "क्रिप्टो जमा करने के लिए आपका मोबाइल नंबर पहले सत्यापित होना चाहिए।",
    crypto_network: "क्रिप्टो नेटवर्क",
    crypto_withdraw_info1: "तुम्हें प्राप्त होगा",
    crypto_withdraw_info2: "आपके ₹ से",
    crypto_withdraw_info3: "अनुरोध",
    currentturnover: "वर्तमान टर्नओवर",
    daily_deposit_limit: "दैनिक जमा सीमा",
    daily_deposit_limit_placeholder: "दैनिक जमा सीमा दर्ज करें",
    dailydepositlimitnegativeamountvalidation:
        "कृपया दैनिक जमा सीमा की एक सकारात्मक राशि दर्ज करें।",
    dailydepositlimitnotes:
        "आपकी ₹{0} की नई दैनिक जमा सीमा {1}घंटे में प्रभावी हो जाएगी।",
    dailylimit_biggerthan_monthlyweekly:
        "दैनिक सीमा साप्ताहिक/मासिक सीमा से बड़ी नहीं हो सकती।",
    date_of_birth: "जन्म की तारीख",
    declined: "अस्वीकृत",
    delete_bank_confirmation: "क्या आप वाकई इस बैंक को हटाना चाहते हैं?",
    deposit: "जमा",
    "deposit processed": "जमा प्रक्रिया",
    deposit_amount_error:
        "आप प्रोमो कोड लागू नहीं कर सकते इसके लिए न्यूनतम राशि आवश्यक है",
    deposit_amount_less_than_hundred: "जमा राशि सौ से अधिक होनी चाहिए।",
    deposit_approved_notification: "आपकी जमा amount स्वीकृत हो गई!",
    deposit_btn: "जमा करें",
    deposit_limit: "जमा सीमा",
    deposit_method: "इस जमा विधि में",
    deposit_rejected_notification: "आपकी जमा amount स्वीकृत नहीं हुई!",
    deposit_revert_confirmation_lable:
        "क्या आप वाकई इस जमा अनुरोध को वापस करना चाहते हैं?",
    deposit_reverted_successfully: "जमा सफलतापूर्वक रद्द किया गया",
    deposit_success_reverted:
        "आपकी जमा राशि वापस कर दी गई है। अब आप नई जमा राशि का अनुरोध कर सकते हैं।",
    deposit_transaction_update_sent: "जमा लेनदेन अद्यतन अनुरोध भेजा गया है।",
    deposit_type: "जमा प्रकार",
    deposit_under_approval: "आपकी जमा राशि स्वीकृति के अधीन है!",
    depositlimitsuccessmessage:
        "आपकी जमा सीमा सफलतापूर्वक निर्धारित कर दी गई है।",
    depositlimitvalidationforblankdata: "कृपया कम से कम एक जमा सीमा दर्ज करें।",
    depositprocessingpara1:
        "आपके पास पहले से ही लंबित जमा पर कार्रवाई की जा रही है। नए जमा अनुरोध को शीघ्र ही अनुमति दी जाएगी।",
    details_verification: "विवरण सत्यापन",
    do_you_want_to_change_password: "क्या आप वाकई पासवर्ड बदलना चाहते हैं?",
    document_approved_message: "आपका पहचान दस्तावेज़ स्वीकृत हो गया है.",
    document_number: "दस्तावेज़ संख्या",
    document_rejected_message: "आपका पहचान दस्तावेज़ अस्वीकार कर दिया गया है.",
    document_upload_successfully: "दस्तावेज़ सफलतापूर्वक सम्मिलित किए गए।",
    dont_have_an_account: "खाता नहीं है?",
    download_app: "ऐप डाउनलोड करें",
    "driver license": "चालक लाइसेंस",
    edit: "संपादित करें",
    edit_bank: "बैंक खाता संपादित करें",
    email: "ईमेल",
    email_address: "ईमेल पता",
    email_error: "कृपया ईमेल आईडी दर्ज करें",
    email_verified: "ईमेल सत्यापित हुआ",
    end: "अंत",
    endbalance: "अंतिम शेष",
    enter_additional_concerns: "अतिरिक्त मुद्दा दर्ज करें",
    enter_amount: "राशि दर्ज करें",
    enter_birthdate: "कृपया जन्मतिथि दर्ज करें",
    enter_confirm_password: "अपने नए पासवर्ड की पुष्टि करें",
    enter_current_password: "अपना वर्तमान पासवर्ड दर्ज करें",
    enter_document_number: "कृपया दस्तावेज़ संख्या दर्ज करें।",
    enter_email: "अपना ईमेल आईडी दर्ज करें",
    enter_full_name: "पूरा नाम दर्ज करें",
    enter_mobile: "कृपया मोबाइल नंबर दर्ज करें",
    enter_new_password: "अपना नया पासवर्ड दर्ज करें",
    enter_reference_number: "कृपया रेफरेंस नंबर दर्ज करें",
    enter_the_4_digit_code_sent_to_your_email_or_phone:
        "आपके ईमेल या फ़ोन पर भेजे गए 4-अंकीय कोड दर्ज करें",
    enter_user_name: "उपयोगकर्ता नाम दर्ज करें",
    enter_valid_amount: "कृपया एक मान्य राशि दर्ज करें",
    enter_valid_reference_number: "कृपया मान्य रेफरेंस नंबर दर्ज करें",
    error: "त्रुटि",
    error_account_locked:
        "आप लॉगिन प्रयासों की अधिकतम संख्या तक पहुंच गए हैं इसलिए आपका खाता अब लॉक हो गया है। अपना खाता अनलॉक करने के लिए ग्राहक सहायता से संपर्क करें।",
    error_CBWB_cant_claimed_due_to_rewardperiod_ended:
        "इस बोनस के लिए रिवॉर्ड अवधि समाप्त हो चुकी है, और कोई आगामी क्रेडिटिंग चक्र नहीं है। इसलिए, इस बोनस का दावा करना या इसके लिए ऑप्ट-इन करना संभव नहीं है।",
    error_ConfirmPassword: "कृपया नये पासवर्ड की पुष्टि करें",
    error_cooldown_period:
        'ऐसा लगता है कि आपको लॉग इन करने में समस्या आ रही है। 3 मिनट में पुनः प्रयास करें या "पासवर्ड भूल गए" पर क्लिक करें और निर्देशों का पालन करें।',
    error_deposit_limit: "कम से कम एक जमा सीमा दर्ज करें",
    error_exceeded_max_attempts:
        "आप अधिकतम प्रयासों को पार कर चुके हैं, कृपया कुछ समय बाद पुनः प्रयास करें।",
    error_Mobile: "अपना मोबाइल नंबर दर्ज करें",
    error_Password: "कृपया पासवर्ड दर्ज करें",
    error_Username: "कृपया अपने उपयोगकर्ता नाम दर्ज करें",
    error_username_password_invalid: "उपयोगकर्ता नाम या पासवर्ड अमान्य है।",
    event_date: "कार्यक्रम की तिथि",
    exchange: "अदला-बदली",
    "exchange bet placed": "एक्सचेंज  बेट लगाई गई",
    "exchange bet settled": "एक्सचेंज शर्त तय हो गई",
    exchange_rules: "अदला-बदली नियम",
    "exchange-rules": "विनिमय नियम",
    exchangebalance: "एक्सचेंज बैलेंस",
    exchangeexposure: "एक्सचेंज एक्सपोजर",
    excluded: "बहिष्कृत",
    expired_bonus_tab: "खत्म हो चुका",
    expires: "समय-सीमा समाप्त",
    expiry_date: "समाप्ति तिथि",
    expiry_date_error: "कृपया भविष्य की दिनांक का चयन करें",
    exchange_yourself: "अदला-बदली!",
    failed_to_copy_password: "पासवर्ड कॉपी करने में विफल",
    failed_to_copy_username: "उपयोगकर्ता नाम कॉपी करने में विफल",
    failed_to_copy_text: "टेक्स्ट कॉपी करने में विफल",
    favouritegames: "पसंदीदा खेल",
    fee: "शुल्क",
    fee_type: "शुल्क प्रकार",
    fees_info: "आप प्राप्त करेंगे :",
    filter: "फ़िल्टर",
    find_your_utr: "अपना UTR खोजें",
    footer_copyright: "© {year} SKY365। सभी अधिकार सुरक्षित हैं।",
    footer_disclaimer: "अस्वीकरण",
    footer_privacy_policy: "गोपनीयता नीति",
    footerpara2:
        "स्काई365 का स्वामित्व और संचालन प्राइमडिजिटल ग्लोबल लिमिटेड द्वारा किया जाता है। पंजीकरण संख्या: 15823, पंजीकृत पता: हमचको, स्वायत्त द्वीप अंजुआन, मुत्सामुडु, कोमोरोस 0000। हमसे संपर्क करें।",
    footerpara3:
        "स्काई365 को कोमोरोस संघ के स्वायत्त द्वीप अंजुआन की सरकार द्वारा लाइसेंस और विनियमित किया जाता है और यह लाइसेंस संख्या ALSI-202502010-FI1 के तहत संचालित होता है।",
    forgot_password: "पासवर्ड भूल गए",
    forgot_password_label: "नया पासवर्ड सेट करें",
    forgot_password_link: "पासवर्ड भूल गए ?",
    free_spin: "निःशुल्क स्पिन",
    freespin_bonus_step: "निःशुल्क स्पिन का उपयोग किया गया",
    full_name: "पूरा नाम",
    game: "खेल",
    game_added_favourite_list: "गेम को आपकी पसंदीदा सूची में जोड़ा गया",
    game_name: "खेल का नाम",
    game_removed_favourite_list: "गेम को आपकी पसंदीदा सूची से हटा दिया गया है",
    games: "गेम्स",
    general_payment_help: "सामान्य भुगतान सहायता",
    general_payment_help_step1: "दिए गए खाते में ₹{amount} स्थानांतरित करें।",
    general_payment_help_step2: "तेज़ प्रसंस्करण के लिए IMPS चुनें।",
    general_payment_help_step3:
        "अपना रेफ. नंबर / ट्रांस. आईडी / यूटीआर दर्ज करें।",
    general_payment_help_step4: "जमा राशि 5 मिनट के भीतर दिखाई देगी।",
    GetApp: "ऐप प्राप्त करें",
    glossary: "शब्दकोष",
    half_lost: "आधी हार",
    half_win: "आधी जीत",
    help: "मदद",
    hey_there: "नमस्ते",
    hi_lbl: "नमस्ते",
    history_select_status: "स्थिति चुनें",
    hold: "होल्ड",
    i_agree_with_terms_and_conditions: "मैं टर्म्स एंड कंडिशन्स के साथ सहमत हूं।",
    identification: "पहचान",
    ifsc: "आईएफएससी",
    img_extention: "कृपया जेपीजी, जेपीईजी या पीएनजी फाइलों का चयन करें",
    img_size: "कृपया 5MB से कम आकार की फ़ाइल चुनें",
    inbox: "इनबॉक्स",
    included: "शामिल",
    info: "ⓘ जानकारी",
    inprogress: "चालू",
    invalid_reference_number_for_type: "{type} के लिए अमान्य रेफरेंस नंबर",
    is_biomatrics: "बॉयोमेट्रिक्स",
    joinNow: "शामिल हों",
    "kyc-policy": "केवाईसी नीति",
    league_name: "लीग का नाम",
    liability: "देयता",
    login: "लॉग इन करें",
    login_again: "पुन: लॉगिन करें.",
    logout: "लॉग आउट",
    logout_confirmation: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
    lost: "हार",
    max: "अधिकतम ₹",
    max_text: "अधिकतम",
    menu: "मेनू",
    message_delete_notify: "संदेश सफलतापूर्वक हटा दिया गया।",
    min: "न्यूनतम ₹",
    min_text: "न्यूनतम",
    minimumodds: "न्यूनतम संभावना",
    mobile: "मोबाइल",
    mobile_email_verification: "03  मोबाइल नंबर या ईमेल सत्यापन",
    mobile_error: "अपना मोबाइल नंबर दर्ज करें।",
    mobile_number: "मोबाइल नंबर",
    mobile_validation_error: "कृपया मान्य मोबाइल नंबर दर्ज करें",
    mobile_verified: "मोबाइल सफलतापूर्वक सत्यापित.",
    month_deposit: "मासिक जमा सीमा",
    monthly_deposit_limit_placeholder: "मासिक जमा सीमा दर्ज करें",
    monthlydepositlimitnegativeamountvalidation:
        "कृपया मासिक जमा सीमा की एक सकारात्मक राशि दर्ज करें।",
    monthlydepositlimitnotes:
        "आपकी ₹{0} की नई मासिक जमा सीमा {1}घंटे में प्रभावी हो जाएगी।",
    needhelp: "मदद चाहिए?",
    new: "नया",
    new_password: "नया पासवर्ड",
    new_password_not_match: "नया पासवर्ड और कन्फर्म पासवर्ड मेल नहीं खाते",
    next: "अगला",
    no: "नहीं",
    no_active_bonus: "कोई सक्रिय बोनस नहीं",
    no_balance_adjustment: "कोई शेष समायोजन नहीं",
    no_bank_details: "कोई बैंकिंग विवरण नहीं मिला",
    no_bonus_details_available: "बोनस के बारे में कोई जानकारी उपलब्ध नहीं है।",
    no_cancelled_bonus: "कोई रद्द बोनस नहीं",
    no_casino_history: "कोई कैसीनो इतिहास नहीं",
    no_consumed_bonus: "कोई उपभोगित बोनस नहीं",
    no_data_found: "कोई डेटा नहीं मिला",
    no_deposit_history: "कोई जमा इतिहास नहीं",
    no_exchange_history: "कोई अदला-बदली इतिहास नहीं",
    no_expired_bonus: "कोई समाप्त बोनस नहीं",
    no_games_found: "कोई गेम नहीं मिला",
    no_records_found: "कोई रिकॉर्ड नहीं मिला",
    no_sports_history: "कोई खेल इतिहास नहीं",
    no_wallet_history: "कोई बटुआ इतिहास नहीं",
    no_withdraw_history: "कोई निकासी इतिहास नहीं",
    not_accepted: "स्वीकार नहीं किया गया",
    odds: "संभावनाएँ",
    ok_btn: "ठीक है",
    ok_response_profile_request_submitted: "प्रोफ़ाइल सफलतापूर्वक अपडेट कर दी गई है",
    ok_response_request_performed_successfully: "आपका अनुरोध सफलतापूर्वक पूरा किया गया है।",
    okay: "ठीक है!",
    onclick_reset_password_label:
        "एक आसान लॉगिन चाहते हैं? नया पासवर्ड सेट करें।",
    oneclick: "एक बार दबाओ",
    only_character_allows: "कृपया केवल अक्षर दर्ज करें",
    open: "खोलना",
    opt_in: "चुनें",
    others: "अन्य",
    over_eighteen_years_old: "मैं 18 साल से अधिक हूं",
    OverEighteenYears_message: "कृपया अपनी उम्र की पुष्टि करें",
    page_not_found: "पृष्ठ नहीं मिला।",
    "pan card": "पैन कार्ड",
    partialrefund: "आंशिक वापसी",
    passport: "पासपोर्ट",
    password: "पासवर्ड",
    password_copied: "पासवर्ड सफलतापूर्वक कॉपी किया गया",
    password_invalid: "पासवर्ड अमान्य है",
    password_changed: "पासवर्ड बदला गया",
    pay_via: "भुगतान करने का तरीका",
    payment: "भुगतान",
    "payment-methods": "भुगतान की विधि",
    payout: "भुगतान",
    pending: "लंबित",
    phone: "फ़ोन",
    placeholder_account_number: "खाता संख्या दर्ज करें",
    placeholder_beneficiary_name: "लाभार्थी का नाम दर्ज करें",
    placeholder_branch_name: "शाखा का नाम दर्ज करें",
    placeholder_ifsc: "आईएफएससी / स्विफ्ट दर्ज करें",
    player: "खेलकर्ता",
    please_confirm_this_below_instructions:
        "कृपया इस नीचे निर्देशों को सत्यापित करें।",
    please_enter_a_valid_number: "कृपया एक मान्य संख्या दर्ज करें",
    please_enter_password: "सत्यापित करने के लिए कृपया पासवर्ड दर्ज करें!",
    please_setup_biomatrics:
        "Sky365 ऐप पर उन्हें सक्रिय करने में सक्षम होने के लिए कृपया अपने डिवाइस पर बायोमेट्रिक्स (फेस आईडी या फ़िंगरप्रिंट) सेटअप करें",
    potentialwin: "संभावित जीत",
    privacy_policy: "गोपनीयता नीति",
    "privacy-policy": "गोपनीयता नीति",
    proceed: "जारी रखें",
    processed_date: "संसाधित तारीख",
    processing: "दावा",
    profile: "प्रोफ़ाइल",
    profile_updated_successfully: "प्रोफ़ाइल सफलतापूर्वक अपडेट कर दी गई है",
    promotion: "प्रोमोशन",
    proof_approval: "01  आईडी प्रूफ़ सत्यापन",
    provider_and_games: "प्रदाता और गेम्स",
    popup_blocker_redirect: "कृपया पॉप-अप सक्षम करें और रीडायरेक्ट को आगे बढ़ने दें।",
    read_all: "सभी को पढ़ा हुआ मार्क करें",
    realmoney: "मुख्य वॉलेट बैलेंस",
    receive_cash_or_bonuses: "नकद और अन्य बोनस प्राप्त करना चाहते हैं?",
    recent_played: "हाल ही में खेला गया",
    ref_tran_utr: "संदर्भ संख्या / लेन-देन आईडी / यूटीआर",
    reference_id: "संदर्भ आईडी",
    reference_number: "संदर्भ संख्या",
    refid_copy_failed: "संदर्भ आईडी कॉपी करने में विफल",
    refid_note:
        "उदाहरण जहां से अपनी जमा पर्ची से संदर्भ संख्या /Trans.ID / UTR से परामर्श करें",
    refid_success_copied: "संदर्भ आईडी सफलतापूर्वक कॉपी की गई",
    refund: "धनवापसी",
    register: "रजिस्टर करें",
    rejected: "अस्वीकार",
    remainingturnover: "शेष टर्नओवर",
    remark: "टिप्पणी",
    remarks: "टिप्पणियां",
    remove: "हटाएं",
    remove_avatar: "अवतार हटाएँ",
    REQUEST_FROM_BLOCKED_USER:
        "भुगतान विधि फिलहाल उपलब्ध नहीं है. कृपया कोई दूसरा प्रयास करें।",
    request_update_btn: "अद्यतन का अनुरोध करें",
    reset_password: "पासवर्ड रीसेट",
    "responsible-gaming": "जिम्मेदार गेमिंग",
    revert: "वापस लौटना",
    revert_deposit_request: "जमा अनुरोध रद्द करें",
    reverted: "वापस लाया गया",
    round_id: "राउंड आईडी",
    rules: "नियम",
    reCAPTCHA_message: "कृपया पुष्टि करें कि आप रोबोट नहीं हैं।",
    saveasimage: "छवि के रूप में सहेजें",
    scan_qr_to_pay: "भुगतान करने के लिए ऊपर दिए QR कोड को स्कैन करें",
    searchgame: "खेल खोज",
    searchtransactionid: "लेनदेन आईडी खोजें",
    select: "चुनें",
    select_account_to_pay: "भुगतान करने के लिए खाता चुनें",
    select_btn: "चुनना",
    select_category_lbl: "श्रेणी चुनें",
    select_crypto_currency: "कृपया क्रिप्टो करेंसी चुनें",
    select_date: "दिनांक अवधि चुनें",
    select_userbank: "कृपया बैंक खाता चुनें",
    select_your_avatar: "अपना अवतार चुनें",
    self_exclusion: "स्वयं बहिष्करण",
    self_exclusion_policy_page: "स्व-बहिष्करण नीति",
    "self-exclusion-policy": "स्व-बहिष्करण नीति",
    selfexcludeconfirmationlabel1:
        "क्या आप सुनिश्चित हैं कि आप अपने Sky365 खाते से स्व-बहिष्कार करना चाहते हैं?",
    selfexcludeconfirmationlabel2:
        "पुष्टि के बाद खाता स्थायी रूप से बंद कर दिया जाएगा।",
    selfexclusionlabel: "मैं अपने खाते को स्वयं बहिष्कृत करना चाहता/चाहती हूं",
    selfexclusionnotes:
        "अपने Sky365 खाते से स्व-बहिष्करण करके आप किसी भी समय अपने खाते में साइन इन या पुनः सक्रिय नहीं कर पाएंगे। स्व-बहिष्करण का अर्थ है कि आपका खाता स्थायी रूप से बंद कर दिया जाएगा। आप Sky365 के साथ एक नया खाता नहीं खोलने के लिए सहमत हैं और Sky365 आपके द्वारा अवैध रूप से बनाए गए किसी भी नए खाते की पहचान करने और उसे बंद करने के लिए हर संभव प्रयास करेगा। Sky365 और आपके बीच सभी संचार भी स्थायी रूप से समाप्त कर दिए जाएंगे।",
    selfexclusionsuccesslabel:
        "आपका Sky356 खाता स्थायी रूप से स्वयं बहिष्कृत है।",
    send: "भेजना",
    send_details_on_email_or_phone: "ईमेल या फ़ोन द्वारा विवरण भेजें",
    session_error_model: "सत्र समाप्त हो गया है! कृपया पुन: लॉगिन करें.",
    signup: "साइन अप करें",
    site_title: "Sky365 - स्पोर्ट्स बेटिंग, ऑनलाइन गेमिंग",
    SMS: "एसएमएस",
    sports: "खेल",
    "sports bet placed": "खेल बेट लगाई गई",
    "sports bet resettled": "खेल शर्त पुनः व्यवस्थित",
    "sports bet settled": "खेल शर्त तय हो गई",
    sports_bet: "खेल दांव",
    sportsbook: "खेल पुस्तक",
    sportsbook_rules: "स्पोर्ट्सबुक नियम",
    "sportsbook-rules": "स्पोर्ट्सबुक नियम",
    sportsIndia: "भारत स्पोर्ट्सबुक",
    sql_error_account_closed:
        "आपका खाता बंद है। कृपया अधिक सहायता के लिए ग्राहक सहायता से संपर्क करें।",
    sql_error_account_not_found:
        "क्षमा करें, हमें सिस्टम में दिए गए विवरण के अनुसार कोई खाता नहीं मिला।",
    sql_error_account_selfexclude: "यह खाता बंद है. ग्राहक समर्थन से संपर्क।",
    sql_error_add_future_expire_date:
        "कृपया दस्तावेज़ की भविष्य की समाप्ति तिथि जोड़ें",
    sql_error_adjustment_already_exists: "मैन्युअल समायोजन पहले से मौजूद है",
    sql_error_amount_after_fee_should_not_Fifty:
        "शुल्क कटौती के बाद राशि पचास से कम नहीं होनी चाहिए। कृपया एक वैध राशि प्रदान करें.",
    sql_error_amount_after_fee_should_not_ten:
        "शुल्क कटौती के बाद राशि दस से कम नहीं होनी चाहिए। कृपया एक वैध राशि प्रदान करें.",
    sql_error_amount_after_fee_should_not_zero:
        "शुल्क कटौती के बाद राशि शून्य नहीं हो सकती. कृपया एक वैध राशि प्रदान करें.",
    sql_error_amount_maximum:
        "बशर्ते कि राशि चयनित बैंक के लिए अधिकतम राशि से अधिक हो",
    sql_error_amount_minimum:
        "बशर्ते कि राशि चयनित बैंक के लिए न्यूनतम राशि से कम हो",
    sql_error_amount_should_between_min_max:
        "राशि निर्दिष्ट न्यूनतम और अधिकतम सीमा के बीच होनी चाहिए।",
    sql_error_amount_should_not_zero: "निकासी की सीमा 10 से 30000 है",
    sql_error_bank_exists_for_user:
        "वॉलेट पता सिस्टम में पहले से मौजूद है। कृपया नया डालें या ग्राहक सहायता से संपर्क करें।",
    sql_error_bank_id_invalid: "बैंक अमान्य है",
    sql_error_birthdate_not_found: "कृपया वैध जन्मतिथि दर्ज करें",
    sql_error_deposit_already_reverted:
        "यह लेन-देन पहले ही वापस किया जा चुका है। आप इसे दोबारा वापस नहीं कर सकते।",
    sql_error_deposit_amount_large_deposit_limit:
        "इच्छित राशि आपके खाते पर निर्धारित दैनिक जमा सीमा से अधिक है। कृपया कम राशि के साथ पुनः प्रयास करें।",
    sql_error_deposit_amount_large_monthly_deposit_limit:
        "इच्छित राशि आपके खाते पर निर्धारित मासिक जमा सीमा से अधिक है। कृपया कम राशि के साथ पुनः प्रयास करें।",
    sql_error_deposit_amount_large_weekly_deposit_limit:
        "इच्छित राशि आपके खाते पर निर्धारित साप्ताहिक जमा सीमा से अधिक है। कृपया कम राशि के साथ पुनः प्रयास करें।",
    sql_error_deposit_final_status_revert_not_allowed:
        "यह लेन-देन पहले ही अपनी अंतिम स्थिति पर पहुंच चुका है, इसलिए अब इसे वापस करना संभव नहीं है।",
    sql_error_deposit_further_status_revert_not_allowed:
        "यह अनुरोध पहले ही संसाधित किया जा चुका है। अब इसे वापस करना संभव नहीं है।",
    sql_error_deposit_not_allowed:
        "जमा प्रकार की अनुमति नहीं है। कृपया अन्य के साथ प्रयास करें।",
    sql_error_deposit_update_request_not_allowed:
        "इस लेनदेन के लिए जमा लेनदेन अद्यतन अनुरोध की अनुमति नहीं है।",
    sql_error_document_exist_for_user:
        "दस्तावेज़ विवरण सिस्टम में पहले से मौजूद है. नए विवरण डालें या ग्राहक सहायता से संपर्क करें।",
    sql_error_email_already_exists:
        "यह ईमेल आईडी पहले से ही पंजीकृत है, कृपया किसी अन्य ईमेल आईडी से प्रयास करें।",
    sql_error_email_not_found: "ईमेल नहीं मिला",
    sql_error_email_not_verified: "आपका ईमेल अभी तक सत्यापित नहीं है",
    sql_error_exchange_balance_negative:
        "नकारात्मक शेष राशि और/या निपटान में बदलाव के कारण आपके वॉलेट के फंड पर प्रभाव पड़ने के कारण यह निकासी अब नहीं की जा सकती है। कृपया कुछ समय बाद पुनः प्रयास करें।",
    sql_error_feetype_disabled:
        "निकासी फिलहाल अनुपलब्ध है, कृपया कुछ समय बाद पुनः प्रयास करें",
    sql_error_for_user_bank_data_exists:
        "जिस बैंक दस्तावेज़ को आप वर्तमान में संपादित कर रहे हैं, उसे आपके शुरू करने के बाद से व्यवस्थापक द्वारा अनुमोदित किया गया है। आगे संपादन की अनुमति नहीं है.",
    sql_error_for_user_proof_data_exists:
        "जिस प्रूफ दस्तावेज़ को आप वर्तमान में संपादित कर रहे हैं, उसे आपके प्रारंभ से ही व्यवस्थापक द्वारा अनुमोदित किया गया है। आगे संपादन की अनुमति नहीं है.",
    sql_error_freespinbonus_exists:
        "उसी गेम के लिए निर्दिष्ट समय सीमा के भीतर बोनस पहले ही निर्धारित किया जा चुका है।",
    sql_error_invalid_user_bank_id: "उपयोगकर्ता बैंक आईडी अमान्य है",
    sql_error_invalid_wallet_address: "उपयोगकर्ता वॉलेट पता अमान्य है",
    sql_error_last_deposit_in_process: "आपकी जमा राशि प्रक्रिया में है",
    sql_error_last_withdraw_in_process:
        "आपकी अंतिम निकासी या तो लंबित है या संसाधित हो रही है",
    sql_error_mobile_already_exists:
        "यह मोबाइल नंबर पहले से ही पंजीकृत है, कृपया किसी अन्य मोबाइल नंबर के साथ प्रयास करें।",
    sql_error_mobile_not_found: "डाला गया मोबाइल नंबर मौजूद नहीं है.",
    sql_error_mobileno_not_verified: "आपका मोबाइल नंबर अभी तक सत्यापित नहीं है",
    sql_error_monthly_is_less_than_daily_amount:
        "आपकी मासिक जमा राशि दैनिक जमा राशि से अधिक होनी चाहिए",
    sql_error_monthly_is_less_than_weekly_amount:
        "आपकी मासिक जमा राशि साप्ताहिक जमा राशि से अधिक होनी चाहिए",
    sql_error_multiple_login:
        "आपको लॉग ऑफ कर दिया गया है क्योंकि आपने किसी अन्य स्थान पर लॉग ऑन किया है।",
    sql_error_new_password_same_as_old_2:
        "आपका नया पासवर्ड आपके वर्तमान पासवर्ड से अलग होना चाहिए!",
    sql_error_otp_expire: "डाला गया कोड समाप्त हो गया है, एक नया कोड पुनः भेजें:",
    sql_error_otp_incorrect: "डाला गया कोड गलत है, कृपया इसे दोबारा डालें!",
    sql_error_password_invalid: "उपयोगकर्ता नाम या पासवर्ड अमान्य है.",
    sql_error_provide_password_confirmpassword_3:
        "नया पासवर्ड' और 'पासवर्ड की पुष्टि करें' मेल नहीं खाते",
    sql_error_provide_valid_old_password_1: "कृपया वैध वर्तमान पासवर्ड दर्ज करें",
    sql_error_record_not_found: "रिकॉर्ड नहीं मिला",
    sql_error_referencenumber_exists:
        "संदर्भ ID/UTR पहले से ही उपयोग किया गया था। कृपया एक नया अपलोड करें।",
    sql_error_user_deactivated: "खाता बंद है।",
    sql_error_user_inactivated:
        "उपयोगकर्ता निष्क्रिय है कृपया प्रशासन विभाग से संपर्क करें।",
    sql_error_user_not_found:
        "उपयोगकर्ता नाम मौजूद नहीं है, कृपया पुनः प्रयास करें।",
    sql_error_username_already_exists:
        "उपयोगकर्ता का नाम पहले से मौजूद है। कृपया भिन्न उपयोक्तानाम के साथ प्रयास करें।",
    sql_error_username_not_exists: "उपयोगकर्ता नाम या पासवर्ड अमान्य है।",
    sql_error_wallet_address_already_exists:
        "वॉलेट एड्रेस पहले से ही सिस्टम में मौजूद है। कृपया नया एड्रेस डालें या कस्टमर सपोर्ट से संपर्क करें।",
    sql_error_weekly_is_less_than_daily_amount:
        "आपकी साप्ताहिक जमा राशि दैनिक जमा राशि से अधिक होनी चाहिए।",
    sql_error_withdraw_amount_less_than_balance:
        "निकासी अनुरोध राशि उपलब्ध शेष राशि से अधिक है।",
    sql_error_withdraw_further_status_revert_not_allowed:
        "आपका अनुरोध व्यवस्थापक द्वारा संसाधित किया जा रहा है. आगे वापसी की अनुमति नहीं है.",
    sql_error_withdraw_revert_not_allowed:
        "वापसी की अनुमति नहीं है. कृपया व्यवस्थापक से संपर्क करें.",
    sql_error_withdraw_type_not_allowed:
        "निकासी प्रकार की अनुमति नहीं है। कृपया अन्य के साथ प्रयास करें।",
    sql_error_withdraw_update_request_not_allowed:
        "इस लेनदेन के लिए निकासी लेनदेन अद्यतन अनुरोध की अनुमति नहीं है।",
    sql_error_withdrawtype_disabled:
        "निकासी फिलहाल अनुपलब्ध है, कृपया कुछ समय बाद पुनः प्रयास करें|",
    sql_previous_password_security:
        "सुरक्षा सुनिश्चित करने के लिए, कृपया अपने पिछले पासवर्ड से अलग एक नया पासवर्ड चुनें।",
    stake: "दांव लगाना",
    start: "शुरू",
    start_deposit: "जमा प्रारंभ करें",
    start_journey: "हमारे साथ अपनी यात्रा शुरू करें",
    startbalance: "शुरुआत शेष",
    status: "स्थिति",
    submit: "प्रस्तुत करना",
    success_copied: "सफलतापूर्वक कॉपी की गई",
    success_popup_message1: "आपका पासवर्ड सफलतापूर्वक बदल गया",
    sure_you_want_delete_this_message:
        "क्या आप निश्चित रूप से यह संदेश हटाना चाहते हैं?",
    swift_ifsc: "स्विफ्ट/आईएफएससी",
    sql_error_amount_after_fee_should_not_hundred: "फ़ी कटौती के बाद राशि सौ से कम नहीं होनी चाहिए। कृपया एक मान्य राशि प्रदान करें।",
    take_a_break: "एक ब्रेक ले लो",
    takeabreakconfirmationlabel: "क्या आप वाकई {0} के लिए ब्रेक लेना चाहते हैं?",
    takeabreaknotes:
        "अपने Sky365 खाते से विराम लेकर आप अनुरोधित अवधि के दौरान अपने खाते में साइन इन या फिर से सक्रिय नहीं कर पाएंगे। ब्रेक लेने का अर्थ है कि आपका खाता एक निश्चित अवधि के लिए सक्रिय नहीं रहेगा। एक ब्रेक लें अवधि के दौरान Sky365 और आपके बीच सभी संचार भी निलंबित कर दिए जाएंगे।",
    takeabreaksuccesslabel:
        "आपका Sky356 खाता तब तक के लिए अस्थायी रूप से अक्षम है:",
    TandC_lbl2: "मंजूर हैं।",
    "terms-and-conditions": "नियम और शर्तें",
    time_period: "एक समय अवधि चुनें",
    total_bonus_amount: "जीती गई बोनस राशि",
    totalodds: "कुल संभावनाएँ",
    "tournament reward": "टूर्नामेंट इनाम",
    transaction: "लेनदेन",
    transaction_update_lbl: "लेन-देन अद्यतन",
    transactionid: "ट्रांस आईडी",
    transactions: "लेनदेन",
    transferred_by: "के माध्यम से स्थानांतरित",
    transid_success_copied: "लेन-देनआईडी सफलतापूर्वक कॉपी की गई",
    trending_games: "ट्रेंडिंग गेम्स",
    try_now: "अब कोशिश करो",
    TandC_message: "कृपया नियम और शर्तें पढ़ें और स्वीकार करें।",
    undo_request: "अनुरोध वापस करें",
    update_transaction_text1: "आपका अनुरोध हमारी टीम द्वारा विश्लेषणाधीन है!",
    update_transaction_text2:
        "एक बार समाप्त होने पर, आपको हमारी प्रतिक्रिया के साथ सूचित किया जाएगा।",
    update_transaction_text3: "आपके धैर्य के लिए धन्यवाद!",
    upiid: "यूपीआई आईडी",
    upload_avatar: "अवतार अपलोड करें",
    upload_bank_document: "अपलोड किया गया बैंक दस्तावेज़",
    uploaded_bank_document: "अपलोड किया गया बैंक दस्तावेज़",
    upload_document_back: "पीछे की छवि",
    upload_document_front: "सामने की छवि",
    upload_document_lbl: "दस्तावेज़ अपलोड करें",
    upload_document_text1:
        "क्या आप भुगतान प्रमाण यहां अपलोड कर सकते हैं या कोई अतिरिक्त चिंता साझा कर सकते हैं?",
    upload_document_text2:
        "*ये फ़ील्ड वैकल्पिक हैं, लेकिन अधिक विवरण साझा करने से हमें आपकी सहायता तेज़ी से करने में मदद मिलेगी।",
    upload_file_document: "फ़ाइल दस्तावेज़ अपलोड करें",
    upload_image_lbl: "जेपीजी, जेपीईजी या पीएनजी प्रारूप स्वीकार किया गया।",
    upload_image_lbl_size: "अधिकतम फ़ाइल आकार 5एमबी।",
    upload_without_attachment_btn: "अनुरोध सबमिट करें",
    username_copied: "उपयोगकर्ता नाम सफलतापूर्वक कॉपी किया गया",
    uptp_3: "3 तक",
    username: "उपयोगकर्ता नाम",
    valid_beneficiary_name: "कृपया वैध लाभार्थी का नाम दर्ज करें",
    valid_branch_name: "कृपया मान्य शाखा का नाम दर्ज करें",
    valid_email: "कृपया एक मान्य ईमेल पता प्रविष्ट करें",
    valid_enter_amount: "कृपया राशि दर्ज करें",
    valid_ifsc_code: "कृपया मान्य IFSC / SWIFT कोड दर्ज करें",
    valid_password_must_contain:
        "पासवर्ड अल्फ़ान्यूमेरिक होना चाहिए और इसमें विशेष अक्षर भी होने चाहिए। (उदा. @_-*)",
    validate_documenttype: "कृपया मान्य @documenttype विवरण दर्ज करें।",
    verfiy_your_number: "अपना नंबर सत्यापित करें",
    verification: "सत्यापन",
    verified: "सत्यापित",
    verify_all_email_preferences:
        "सक्षम करने के लिए आपको अपना ईमेल सम्मिलित करना और सत्यापित करना होगा!",
    verify_btn: "सत्यापित करें",
    verify_details: "कृपया अपना विवरण सत्यापित करें!",
    verify_email_preferences:
        "ईमेल संपर्क सक्षम करने के लिए आपको अपना ईमेल सम्मिलित करना और सत्यापित करना होगा!",
    verify_mobile_preferences:
        "एसएमएस सक्षम करने के लिए आपको अपना मोबाइल नंबर डालना और सत्यापित करना होगा!",
    verify_otp: "ओटीपी सत्यापित करें",
    verify_your_email: "अपना ईमेल सत्यापित करें",
    voided: "अमान्य",
    valid_username: "कृपया मान्य उपयोगकर्ता नाम दर्ज करें",
    wallet: "बटुआ",
    wallet_address: "बटुआ पता",
    wallet_id: "वॉलेट आईडी",
    wallethistory: "बटुआ इतिहास",
    walletid_copy_failed: "वॉलेट आईडी कॉपी करने में विफल",
    walletid_success_copied: "वॉलेट आईडी सफलतापूर्वक कॉपी की गई",
    weekly_deposit: "साप्ताहिक जमा सीमा",
    weekly_deposit_limit_placeholder: "साप्ताहिक जमा सीमा दर्ज करें",
    weeklydepositlimitnegativeamountvalidation:
        "कृपया साप्ताहिक जमा सीमा की एक सकारात्मक राशि दर्ज करें।",
    weeklydepositlimitnotes:
        "आपकी ₹{0} की नई साप्ताहिक जमा सीमा {1} घंटे में प्रभावी हो जाएगी।",
    weeklylimit_biggerthan_weekly:
        "साप्ताहिक सीमा मासिक सीमा से बड़ी नहीं हो सकती.",
    welcome: "स्वागत!",
    welcome_back: "आपका स्वागत है",
    whatsapp: "व्हाट्सप्प",
    whatsapp_reset_password_label: "नया पासवर्ड सेट करें",
    Whatsapp_Telegram: "व्हाट्सएप / टेलीग्राम",
    Widthdrawable_Bal: "निकासी योग्य शेष राशि :",
    win: "जीत",
    winning_boost: "विजयी प्रोत्साहन",
    winning_boost_days: "विजयी प्रोत्साहन दिन",
    winning_boost_dates: "विजयी प्रोत्साहन तिथियाँ",
    winning_boost_play_time: "विजयी प्रोत्साहन खेलने का समय",
    withdraw: "निकालना",
    "withdraw pending": "निकासी लंबित है",
    "withdraw processed": "निकालना प्रस्तुत",
    "withdraw rejected": "निकासी अस्वीकृत",
    "withdraw reverted": "निकासी पुनर्स्थापित",
    withdraw_approved_notification: "आपकी amount निकासी स्वीकृत हो गई थी!",
    withdraw_approved_utr_notification:
        "आपकी amount निकासी स्वीकृत हो गई थी. लेनदेन UTR है utrnumber!",
    withdraw_get: "आपको मिलने वाली राशि:",
    withdraw_mobile_verify_note:
        "क्रिप्टो निकासी करने के लिए पहले आपका मोबाइल नंबर सत्यापित होना चाहिए।",
    withdraw_note:
        "निकासी का अनुरोध करने के लिए, आपको नीचे दिए गए 3 चरणों को पूरा करना होगा",
    withdraw_process: "आपकी वापसी प्रक्रिया में है!",
    withdraw_rejected_notification: "आपकी amount निकासी स्वीकृत नहीं हुई!",
    withdraw_revert_confirmation_label:
        "क्या आप निश्चित रूप से इस निकासी को वापस अपने Sky365 खाते में वापस कर देंगे",
    withdraw_revert_confirmation_lable:
        "क्या आप निश्चित रूप से इस निकासी को वापस अपने Sky365 खाते में वापस कर देंगे?",
    withdraw_status: "निकासी की स्थिति की जाँच करें",
    withdraw_success_reverted:
        "आपकी निकासी वापस कर दी गई. अब आप नई निकासी का अनुरोध कर सकते हैं।",
    withdraw_top_lbl: "अपनी निकासी विधि चुनें",
    withdraw_transaction_update_sent: "निकासी लेनदेन अद्यतन अनुरोध भेजा गया है।",
    withdraw_type: "निकासी प्रकार",
    withdrawable: "निकासी योग्य बैलेंस",
    withdrawal_amount: "निकासी राशि",
    withdrawal_fee: "निकासी शुल्क",
    withdrawProcessingDetails:
        "एक समय में केवल एक ही निकासी की अनुमति है। आपकी पिछली निकासी प्रक्रिया में है। शीघ्र ही एक नई निकासी का अनुरोध स्वीकार किया जाएगा।",
    write_your_additiona_concerns: "अपनी अतिरिक्त मुद्दा लिखें",
    yes: "हाँ",
    you_cannot_apply_this_promocode: "आप इस प्रोमोकोड को लागू नहीं कर सकते हैं।",
    your_market_your_move: "आपका बाज़ार. आपका निर्णायक।",
};

export default hi;